import type { JSX } from 'solid-js';
import { t } from '../../i18n';

// "Running hot. <name> has the most room." (#6785) as ONE translated sentence, the name in
// bold: the translator places `{name}` where its language wants it, and the sentence is cut
// around a marker no copy contains.

const MARK = '\u0000';

export function HotSentence(props: { readonly name: string }): JSX.Element {
  const parts = (): string[] => t('fleet.machines.card_hot', { name: MARK }).split(MARK);
  return (
    <span>
      {parts()[0]}
      <b>{props.name}</b>
      {parts().slice(1).join('')}
    </span>
  );
}
